import styled from 'styled-components';
import BgPortais from 'assets/images/robo-sale/background-portais.svg';

export const Container = styled.div`
  .position-one {
    position: relative;
    z-index: 1;
    margin-top: 100px;
  }

  .bg-img {
    margin: -100px 0 100px 0;
    padding: 25px 0 25px 0;
    background-color: #0d875e;
    clip-path: polygon(0 15%, 70% 0, 100% 0, 100% 100%, 0 100%);

    @media only screen and (max-width: 768px) {
      margin: 100px 0 100px 0;
      clip-path: polygon(0 0%, 70% 0, 100% 0, 100% 100%, 0 100%);
    }
  }

  .bg-portais {
    background-image: url('${BgPortais}');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-x: right;
    @media only screen and (max-width: 768px) {
      background-image: none;
    }
  }

  .session-one .card {
    border-radius: 36px;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
  }

  .session-one .card p {
    color: #fff;
    font-size: 20px;
  }

  .session-one .card img {
    width: 45px;
  }

  .icon-text {
    display: flex;
    align-items: center;
  }

  .icon {
    margin-right: 8px;
  }

  .icon-2 {
    color: #21354a;
  }

  button {
    border-radius: 40px;
    font-weight: bold;
  }
  .button-green {
    border-radius: 30px;
    background-color: #0c8d62;
  }

  h1,
  h4,
  h2 {
    color: #21354a;
  }

  .margin {
    margin-top: 180px;
  }

  .preco-antigo {
    color: #21354a;
    font-size: 39.379px;
    text-decoration-line: strikethrough;
  }

  span .preco-novo {
    color: #21354a;
    font-size: 47.809px;
    font-weight: 700;
  }

  strong {
    color: #21354a;
  }

  .container-video {
    border: 5px solid #f0f1f2;
    border-radius: 20px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
    background: #f0f1f2;

    @media only screen and (max-width: 768px) {
      border: 0;
      box-shadow: none;
      background: none;
    }
  }

  .bg-dark {
    background-color: #21354a !important;
    padding: 55px;
  }

  @media only screen and (max-width: 768px) {
    .margin {
      margin: 0;
    }

    .bg-green {
      background-color: #0d875e;
      border-radius: 12px;
    }
  }

  .robo {
    margin-bottom: -110px;
  }

  .text {
    font-size: 26px;
  }
  .text-img {
    font-size: 18px;
    color: #21354a;
  }
`;
